import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <g strokeLinecap="round" strokeMiterlimit={10} strokeWidth={1.2}>
      <path d="M7.599 5.224c-2.454.262-4.197 2.637-3.911 5.298.671 6.267 9.226 8.603 9.226 8.603s7.847-4.094 7.176-10.36c-.286-2.662-2.485-4.558-4.945-4.35-4.032.339-4.715 3.89-2.897 4.667 1.056.447 2.727-1.022 1.076-2.677-1.817-1.806-3.835-1.31-3.835-1.31" />
      <path
        d="M20.09 8.765c-.286-2.662-2.485-4.558-4.945-4.35-4.032.338-4.715 3.89-2.897 4.667 1.056.447 2.728-1.022 1.076-2.677-1.817-1.806-3.835-1.31-3.835-1.31"
        style={{
          stroke: "var(--icon-accent,#E47B53)",
        }}
      />
    </g>
  </svg>
);
export const Heart2Icon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
